import React, { Component } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
    GoogleMap,
    LoadScript,
    DirectionsRenderer,
    DirectionsService,
} from "@react-google-maps/api";
import { Polyline } from "@react-google-maps/api";

import driverImage from "../../index2.jpg";

import passengerImage from "../../index4.jpg";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Rating from "@mui/material/Rating";

import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RoundaboutLeftIcon from '@mui/icons-material/RoundaboutLeft';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import Badge from '@mui/material/Badge';
import Spinner from '../Spinner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <ViewReservation {...props} match={match} />;
    };
}

// const containerStyle = {
//     height: "400px",
//     width: "400px",

//   };

const center = {
    lat: 8.98,
    lng: 38.75,
};

const onLoad = (polyline) => {
    console.log("polyline: ", polyline);
};

const path = [
    { lat: 9.0205, lng: 38.8024 },
    { lat: 8.9831, lng: 38.8101 },
];

const options = {
    strokeColor: "#FF0000",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#FF0000",
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 100,

    paths: [
        { lat: 40.6655101, lng: -73.89188969999998 },
        { lat: 40.659569, lng: -73.933783 },
    ],
    zIndex: 1,
};

export class ViewReservation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            passengerId: "",
            pickUpLocationLatitude: "",
            pickUpLocationLongitude: "",
            destinationLocationLatitude: "",
            destinationLocationLongitude: "",
            destinationTime: "",
            pickUpTime: "",
            dropOffTime: "",
            driverFirstName: "",
            driverLastName: "",
            driverPhoneNumber: "",
            driverRating: "",
            driverImage: "",

            passengerFirstName: "",
            passengerLastName: "",
            passengerPhoneNumber: "",
            passengerRating: "",
            passengerImage: "",
            response: null,
            travelMode: "DRIVING",
            origin: "",
            destination: "",
            lat: "",
            lng: "",

            trips: [],
            driver: "",
            loading: true
        };

        this.directionsCallback = this.directionsCallback.bind(this);
        this.checkDriving = this.checkDriving.bind(this);
        this.checkBicycling = this.checkBicycling.bind(this);
        this.checkTransit = this.checkTransit.bind(this);
        this.checkWalking = this.checkWalking.bind(this);
        this.getOrigin = this.getOrigin.bind(this);
        this.getDestination = this.getDestination.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onMapClick = this.onMapClick.bind(this);
    }

    directionsCallback(response) {
        console.log(response);

        if (response !== null) {
            if (response.status === "OK") {
                this.setState(() => ({
                    response,
                }));
            } else {
                console.log("response: ", response);
            }
        }
    }

    checkDriving({ target: { checked } }) {
        checked &&
            this.setState(() => ({
                travelMode: "DRIVING",
            }));
    }

    checkBicycling({ target: { checked } }) {
        checked &&
            this.setState(() => ({
                travelMode: "BICYCLING",
            }));
    }

    checkTransit({ target: { checked } }) {
        checked &&
            this.setState(() => ({
                travelMode: "TRANSIT",
            }));
    }

    checkWalking({ target: { checked } }) {
        checked &&
            this.setState(() => ({
                travelMode: "WALKING",
            }));
    }

    getOrigin(ref) {
        this.origin = ref;
    }

    getDestination(ref) {
        this.destination = ref;
    }

    onClick() {
        if (this.origin.value !== "" && this.destination.value !== "") {
            this.setState(() => ({
                origin: this.origin.value,
                destination: this.destination.value,
            }));
        }
    }

    onMapClick(...args) {
        console.log("onClick args: ", args);
    }
    notifyError = () => toast.error('Something went wrong ...', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    componentDidMount() {
        let id = this.props.match.params.id;
        axios.get("/sharedTripDetails/" + id).then((res) => {
            console.log("da0", res.data[0].pickUpLocationLatitude);
            this.setState({

                trips: res.data,
                driver: res.data[0].driver,
                loading: false,
                origin: res.data[0].pickUpLocationLatitude + ',' + res.data[0].pickUpLocationLongitude,
                destination: res.data[0].destinationLocationLatitude + ',' + res.data[0].destinationLocationLongitude,



            });


        }).catch(err => {
            this.notifyError();
        });

    }

    render() {

        var newLat;
        var newLng;

        if (this.state.lat !== null) {
            newLat = this.state.lat.replace(/^"(.*)"$/, '$1');
            newLng = this.state.lng.replace(/^"(.*)"$/, '$1');
        }

        if (this.state.loading) {

            return (<div>

                <Spinner />
            </div>);

        }
        if (!this.state.loading) {
            return (
                <LoadScript googleMapsApiKey={process.env.GOOGLE_MAP_API_KEY}>
                    <div className="row" style={{ marginLeft: 300, marginTop: 30 }}>
                        <div className="col-md-2">
                            <Card sx={{ maxWidth: 300 }}>
                                <CardActions>
                                    <Button size="small">Driver</Button>
                                </CardActions>

                                <img src={process.env.REACT_APP_BASE_URL +
                                    this.state.driver.driverImage} width="300px" height="200px"></img>
                                <CardContent>
                                    <Typography gutterBottom variant="h6" component="div">
                                        <PersonIcon color="primary" /> {this.state.driver.firstName} &nbsp;{this.state.driver.lastName}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        <Rating
                                            name="read-only"
                                            value={this.state.driver.rating}
                                            readOnly
                                        />

                                        <LocalPhoneIcon color="primary" /> {this.state.driver.phoneNumber}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </div>
                        <div className="col-md-10">
                            <Card sx={{ maxWidth: 1200 }}>
                                <CardActions>
                                    <Button size="small">Passengers</Button>
                                </CardActions>


                                <CardContent>
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>

                                                <th>Activity</th>
                                                <th>Passenger</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>Pick Up Time</th>
                                                <th>Drop Off Time</th>
                                                <th>Amount Paid</th>
                                                <th >Date</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.trips.map(trip => {

                                                if (trip.createdAt === undefined || trip.createdAt === null) {


                                                } else {
                                                    return (<tr>

                                                        {trip.sharedTripRequestId == "Owner" && <td><span class="badge bg-success">Started Trip</span></td>}
                                                        {trip.sharedTripRequestId != "Owner" && <td><span class="badge bg-info">Shared Trip</span></td>}

                                                        <td>{trip.passenger.firstName + ' ' + trip.passenger.lastName}</td>

                                                        <td> {trip.pickUpLocationLatitude + ', ' + trip.pickUpLocationLongitude}</td>
                                                        <td> {trip.destinationLocationLatitude + ', ' + trip.destinationLocationLongitude}</td>
                                                        <td> {trip.pickUpTime.substring(0, 19)}</td>

                                                        {trip.dropOffTime != null &&


                                                            <td> {trip.dropOffTime.substring(0, 19)}</td>}
                                                        {trip.dropOffTime == null&&


                                                            <td> N/A</td>}                                                        {trip.status == "Active" &&
                                                            <td>{trip.estimatedPrice.substring(0, 6)} ETB- Estimated</td>
                                                        }
                                                        {trip.status == "Ended" &&
                                                            <td>{trip.actualPrice.substring(0, 6)} ETB</td>
                                                        }

                                                        <td>{trip.createdAt.substring(0, 10)}</td>
                                                        {trip.status == "Active" &&
                                                            <td><span class="badge bg-warning">Active</span></td>
                                                        }
                                                        {trip.status == "Ended" &&
                                                            <td><span class="badge bg-success">Completed</span></td>
                                                        }

                                                    </tr>)

                                                }

                                            })}
                                        </tbody>
                                    </table>
                                </CardContent>
                            </Card>
                        </div>



                    </div>




                    <div className="map-container">
                        <GoogleMap
                            // required
                            id="direction-example"
                            // required
                            mapContainerStyle={{
                                height: "350px",
                                width: "1250px",
                                marginLeft: "300px",
                                marginRight: "10px",
                                marginTop: "100px",
                            }}
                            // required
                            zoom={2}
                            // required
                            center={{
                                lat: 0,
                                lng: -180,
                            }}
                            // optional
                            onClick={this.onMapClick}
                            // optional
                            onLoad={(map) => {
                                console.log("DirectionsRenderer onLoad map: ", map);
                            }}
                            // optional
                            onUnmount={(map) => {
                                console.log("DirectionsRenderer onUnmount map: ", map);
                            }}
                        >
                            {this.state.destination !== "" && this.state.origin !== "" && (
                                <DirectionsService
                                    // required
                                    options={{
                                        destination: this.state.destination,
                                        origin: this.state.origin,
                                        travelMode: this.state.travelMode,
                                        // waypoints: [{
                                        //     "location": {
                                        //         "id": "ID of FIrst Place",
                                        //         "lat": newLat,
                                        //         "lng": newLng
                                        //     }
                                        // }]
                                    }}

                                    // required
                                    callback={this.directionsCallback}
                                    // optional
                                    onLoad={(directionsService) => {
                                        console.log(
                                            "DirectionsService onLoad directionsService: ",
                                            directionsService
                                        );
                                    }}
                                    // optional
                                    onUnmount={(directionsService) => {
                                        console.log(
                                            "DirectionsService onUnmount directionsService: ",
                                            directionsService
                                        );
                                    }}
                                />
                            )}

                            {this.state.response !== null && (
                                <DirectionsRenderer
                                    // required
                                    options={{
                                        directions: this.state.response,
                                    }}
                                    // optional
                                    onLoad={(directionsRenderer) => {
                                        console.log(
                                            "DirectionsRenderer onLoad directionsRenderer: ",
                                            directionsRenderer
                                        );
                                    }}
                                    // optional
                                    onUnmount={(directionsRenderer) => {
                                        console.log(
                                            "DirectionsRenderer onUnmount directionsRenderer: ",
                                            directionsRenderer
                                        );
                                    }}
                                />
                            )}
                        </GoogleMap>
                    </div>

                    {/* </GoogleMap> */}
                </LoadScript>
            );
        }
    }
}
export default withRouter(ViewReservation);
